import apiFFM from "../apiFFM"

export const getSuppliers = () => {
    return apiFFM.makeAuthRequest({
        url: `/supplier/v2/suppliers`,
        method: 'GET',
    })
}